import { defineApp, localOnly, shortcut } from "@tchoma/app";

export default defineApp({
  id: "dev.tchoma.inbox",
  name: "Inbox",
  version: "0.1.0",
  description: "A deliberately generic local-only capture app built only with public tchoma APIs.",
  icon: {
    source: "./public/icon.svg",
    shortcutGlyph: "sparkles",
    shortcutColor: "coral",
  },
  screenshots: ["./public/screenshots/main.svg"],
  surfaces: {
    web: {
      entry: "./index.html",
      publicUrl: "https://tchoma-inbox.pages.dev/",
      display: "standalone",
      offline: true,
    },
    shortcut: shortcut("./shortcut/main.ts", {
      accepts: ["text", "url", "image", "file"],
      showInShareSheet: true,
    }),
  },
  capabilities: ["share.receive", "network"],
  network: { allowedOrigins: ["https://tchoma-inbox.pages.dev"] },
  data: localOnly(),
  minimum: { ios: "26.0", macos: "26.0" },
  bridgeProtocol: 1,
  migrationVersion: 1,
  shortcutShell: ">=0.1 <1",
  updateCompatibility: ">=0.1 <1",
});
